import { useState } from 'react';

import DataSourceList from './DataSourceList';
import DataSourcesMenuBar from './components/DataSourcesMenuBar';

function DataSourceListHOC() {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div data-testid="datasource-select" className="tw:flex-1 tw:min-h-0 tw:flex tw:flex-col">
      <DataSourcesMenuBar setSearchTerm={setSearchTerm} />

      <DataSourceList searchTerm={searchTerm} />
    </div>
  );
}

export default DataSourceListHOC;
